export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-500 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a href="#hero" className="font-heading text-2xl tracking-wide text-background-50 mb-3 inline-block cursor-pointer">
              贝勒漫画
            </a>
            <p className="text-xs text-background-50/70 leading-relaxed mt-2 max-w-xs">
              贝勒漫画网是贝勒漫画官方入口，提供app下载、最新网址及在线观看服务，
              让您快速访问贝勒漫画所有热门资源，顺畅阅读韩漫日漫国漫。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#app" className="w-9 h-9 rounded-lg bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors cursor-pointer">
                <i className="ri-smartphone-line text-background-50"></i>
              </a>
              <a href="#contact" className="w-9 h-9 rounded-lg bg-background-50/15 flex items-center justify-center hover:bg-background-50/25 transition-colors cursor-pointer">
                <i className="ri-mail-line text-background-50"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#hero" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">首页</a>
              <a href="#app" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">APP下载</a>
              <a href="#features" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">特色功能</a>
              <a href="#cards" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">热门推荐</a>
              <a href="#index" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">专题合集</a>
              <a href="#ranking" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">热门榜单</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">漫画分类</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#media" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">韩漫推荐</a>
              <a href="#media" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">日漫连载</a>
              <a href="#media" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">国漫精选</a>
              <a href="#topics" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">热门话题</a>
              <a href="#carousel" className="text-xs text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">焦点专题</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-background-50/50 leading-relaxed">
              贝勒漫画与多家国内外漫画版权方及内容平台保持合作关系，
              持续为读者引进优质正版漫画资源。
            </p>
            <p className="text-xs text-background-50/40 mt-3">
              合作咨询：contact@beilecomic.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">
            &copy; 2020-2026 贝勒漫画网 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/50">
            <span>贝勒漫画官网入口</span>
            <span>·</span>
            <span>贝勒漫画网址在线看</span>
            <span>·</span>
            <span>贝勒漫画app下载</span>
          </div>
        </div>
      </div>
    </footer>
  );
}